import React from 'react';
import * as S from './style';
import { ReactComponent as CheckBlack } from 'assets/img/common/ic_check_black.svg';
import { ReactComponent as CheckWhite } from 'assets/img/common/ic_check_white.svg';

interface Props {
    inputName: string;
    color: string;
    width?: number;
    height?: number;
    checked?: boolean;
    value?: string | number;
    onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

function BtnColor({ inputName, color, checked, ...props }: Props): React.ReactElement {
    return (
        <S.BtnContainer color={color} {...props}>
            <S.BtnColor type={'checkbox'} name={inputName} {...props} />
            {checked ? color === 'gray_opacity_50' ? <CheckBlack /> : <CheckWhite /> : null}
        </S.BtnContainer>
    );
}

export default BtnColor;
